import axios from 'axios';
import spotify from './spotify.vue';
import g4gBlock from '../g4g/g4g-block.vue';
import VideoPlayer from '../videoJs/videojs.vue';
import singleProductCard from './product-card/singleProdCard.vue';
import productCard from '../collections/collection-card/product-card.vue';
import { Navigation, Pagination, Lazy, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { SpotifyPlacement, ArticleComponent } from '../enums/strapi';
import { ColorwaySort } from '../enums/collections';
import { collectionFilter } from '../mixins/collectionFilter';
import storyCard from './story-card/story-card.vue';
import loadingAnimation from '../loading-animation.vue';

export default {
  name: 'commonThreadStory',
  components: {
    spotify,
    g4gBlock,
    VideoPlayer,
    singleProductCard,
    productCard,
    storyCard,
    loadingAnimation,
    Swiper,
    SwiperSlide,
  },
  setup() {
    const onSwiper = (swiper) => {};
    const onSlideChange = () => {};
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, A11y],
    };
  },
  mixins: [collectionFilter],
  data() {
    return {
      articleBody: [],
      ArticleComponent,
      authors: [],
      bgUrl: '',
      category: '',
      ColorwaySort,
      colorwaySort: ColorwaySort.current,
      date: '',
      inlineVideo: '',
      loading: true,
      readTime: '',
      relatedStories: [],
      SpotifyPlacement,
      spotifyPlacement: '',
      spotifyLink: '',
      spotifyImg: '',
      spotifyDesc: '',
      spotifyTitle: '',
      storyNotFound: false,
      title: '',
      vanityUrl: '',
      videoHeaderUrl: false,
      videoOptionsHero: {
        autoplay: false,
        controls: true,
        preload: true,
        fluid: true,
        poster: '',
        sources: [
          {
            src: '',
            type: 'video/mp4',
          },
        ],
      },
      showTitle: true,
    };
  },
  methods: {
    goBack() {
      //goes back to last page so you can hit landing or archive page depending how you got into the story
      if (document.referrer.includes('common-thread')) {
        window.history.go(-1);
        return false;
      } else {
        //default to go back to landing page if you didnt come from a common thread url
        window.location.href = `/pages/common-thread`;
      }
    },
    formatDateString(dateString) {
      const date = new Date(dateString);
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return date.toLocaleDateString(undefined, options);
    },
    getData() {
      //gets story data based off vanity url
      let url = window.location.pathname;
      //removes potential trailing slash
      if (url.endsWith('/')) {
        url = url.slice(0, -1);
      }
      this.vanityUrl = url.split('/').slice(-1)[0];
      //checks for preview=true param and will adjust endpoint to retrieve draft stories
      let previewParam = new URL(window.location.href).searchParams.get(
        'preview'
      );
      axios
        //strapi endpoint and query param explaination : gets a specific story definded in url
        //populate[heroMedia][populate]=* : populates all hero media data
        //populate[authors]=* : populates all author data
        //populate[category]=* : populates category name

        // need to specifically ask for all components in the article builder since this comes from a dynamic zone in strapi
        // populate[articleBuilder][on][product.product][populate][inlineProduct][populate]=* : gets any products added to article builder
        // populate[articleBuilder][on][wysiwyg.text-field][populate]=* : populates wysiwyg text added to article builder
        // populate[articleBuilder][on][block-quote.block-quote][populate]=* : populates block quotes added to article builder
        // populate[articleBuilder][on][featured-products-header.featured-products-header][populate]=* : populates product header text added to article builder
        // populate[articleBuilder][on][video.video-upload][populate]=* : populates video uploads added to article builder
        // populate[articleBuilder][on][video.video-embed][populate]=* : populates embedded videos added to article builder

        // populate[relatedStories][populate]=* : populates all related story data if added
        // filters[vanityUrl][$eq]=${this.vanityUrl} : filters story that matches vanity url
        // publicationState=preview : if we have a preview parameter in the url, return a story in draft state
        .get(
          `https://cms.cotopaxi.com/api/stories?populate[heroMedia][populate]=*&populate[authors]=*&populate[category]=*&populate[articleBuilder][on][product.product][populate][inlineProduct][populate]=*&populate[articleBuilder][on][photo.inline-photo][populate][articlePhoto][populate]=*&populate[articleBuilder][on][wysiwyg.text-field][populate]=*&populate[articleBuilder][on][block-quote.block-quote][populate]=*&populate[articleBuilder][on][featured-products-header.featured-products-header][populate]=*&populate[articleBuilder][on][video.video-upload][populate]=*&populate[articleBuilder][on][video.video-embed][populate]=*&populate[relatedStories][populate]=*&filters[vanityUrl][$eq]=${
            this.vanityUrl
          }${previewParam ? '&publicationState=preview' : ''}`
        )
        .then((response) => {
          if (response.data.data.length > 0) {
            let data = response.data.data[0].attributes;
            //set header photo/video + default header image if hero not provided
            if (data.heroMedia.heroPhoto.data) {
              this.bgUrl = data.heroMedia.heroPhoto.data.attributes.url;
            } else {
              this.bgUrl =
                'https://cdn.shopify.com/s/files/1/0281/7544/files/default-insta-header.jpg?v=1701213684';
            }
            //set video hero behind poster image if it exists
            if (data.heroMedia.heroVideo.data) {
              this.videoHeaderUrl = true;
              this.videoOptionsHero.sources[0].src =
                data.heroMedia.heroVideo.data.attributes.url;
              this.videoOptionsHero.poster = this.bgUrl;
            }
            //set story details
            this.title = data.title;
            this.readTime = data.readTime;
            this.category = data.category.data.attributes.categoryName;
            this.date = data.posted_date;

            //build authors array
            data.authors.data.forEach((auth) => {
              this.authors.push(auth.attributes.name);
            });
            //set story components array
            this.articleBody = data.articleBuilder;

            //determin if articleBody contains products
            const foundProducts = this.findProductsInArticle(
              this.articleBody,
              '__component',
              'product.product'
            );

            if (foundProducts) {
              //get product ID(s) and build comma separated string for api request
              let productIds = '';
              foundProducts.inlineProduct.forEach((prod) => {
                productIds +=
                  prod.product.data.attributes.ShopifyProductId + ',';
              });
              //remove trailing comma
              if (productIds.endsWith(',')) {
                productIds = productIds.slice(0, -1);
              }
              foundProducts.productIds = productIds;
              //gets product data from access api
              axios
                .get(
                  `https://production-access-api.cotopaxi.com/product/getProductsForStorefrontByProductIds/${productIds}`
                )
                .then((res) => {
                  if (res.data) {
                    foundProducts.productData = res.data.products;

                    //sets first colorway to active
                    foundProducts.productData.forEach((product) => {
                      product.isDelDia = false;
                      if (product.colorways.length > 0) {
                        this.sortColorways(product, this.colorwaySort);
                        this.switchImages(
                          product.colorways[0].name,
                          product.colorways[0].image,
                          product,
                          false,
                          product.colorways[0].price,
                          product.colorways[0].compareAtPrice
                        ); //set the first swatch to be the 'active' one.
                      } else if (
                        product.hasOwnProperty('delDiaVersion') &&
                        product.delDiaVersion.inventory != 'none' &&
                        product.delDiaVersion.url !== null &&
                        product.delDiaVersion.url !== '' &&
                        typeof product.delDiaVersion.url !== 'undefined'
                      ) {
                        this.switchImages(
                          'delDia',
                          null,
                          product,
                          true,
                          product.delDiaVersion.price,
                          product.delDiaVersion.price
                        ); //if we have no color swatches, then we need to set the del dia item as the active swatch.
                      }
                      //gets yotpo review data
                      return axios
                        .get(
                          `https://production-access-api.cotopaxi.com/yotpo/bottomLine/${product.shopifyProductId}`
                        )
                        .then((response) => {
                          product.numReviews =
                            response.data.bottomline.total_review;
                          product.numStars =
                            response.data.bottomline.average_score;
                          this.isLoading = false;
                        })
                        .catch((err) => {
                          //console.log(err);
                          this.isLoading = false;
                        });
                    });
                  }
                });
            }

            //related stories
            if (data.relatedStories.length > 0) {
              let relatedStoryIds = [];
              data.relatedStories.forEach((story) => {
                let id = story.stories.data[0].id;
                relatedStoryIds.push(id);
              });
              //gets the story IDs from related stories, and makes a request to get details to build the story cards
              //params explained
              //populate[category]=* : gets story category
              //populate[heroMedia][populate][0]=heroPhoto : gets hero photo
              //filters[id][$in][0]=${relatedStoryIds[x]} : filters stories by related story ID
              axios
                .get(
                  `https://cms.cotopaxi.com/api/stories?populate[category]=*&populate[heroMedia][populate][0]=heroPhoto&filters[id][$in][0]=${relatedStoryIds[0]}&filters[id][$in][1]=${relatedStoryIds[1]}&filters[id][$in][2]=${relatedStoryIds[2]}`
                )
                .then((res) => {
                  this.relatedStories = res.data.data;
                })
                .catch((err) => {
                  this.error = true;
                });
            }
            this.getSpotifyInfo();
            this.loading = false;
          } else {
            this.loading = false;
            this.storyNotFound = true;
          }

          //update metadata for SEO
          // Find the existing OG title meta tag
          let ogTitleTag = document.querySelector('meta[property="og:title"]');

          // Update the content attribute with the new OG title
          if (ogTitleTag) {
            console.log('OG title changed to: ' + this.title);
            ogTitleTag.setAttribute('content', this.title);
          }

          // // Find the existing meta description tag
          // var metaDescriptionTag = document.querySelector('meta[name="description"]');

          // // Update the content attribute with the new description
          // if (metaDescriptionTag) {
          //   metaDescriptionTag.setAttribute('content', this.title);
          // }
        })

        .catch((error) => {
          console.error(error);
        });

    },

    getSpotifyInfo() {
      axios
        .get('https://cms.cotopaxi.com/api/landing-page?populate=*')
        .then((response) => {
          const spotifyData = response.data.data.attributes;
          this.spotifyPlacement = spotifyData.spotifyPlacement;
          if (this.spotifyPlacement === SpotifyPlacement.allPages) {
            this.spotifyLink = spotifyData.spotifyPlaylistLink;
            this.spotifyTitle = spotifyData.spotifyTitle;
            this.spotifyDesc = spotifyData.spotifyDescription;
            if (spotifyData.spotifyImage.data) {
              this.spotifyImg = spotifyData.spotifyImage.data.attributes.url;
            }
          }
        });
    },
    findProductsInArticle(arr, key, value) {
      return arr.find((obj) => obj[key] === value);
    },
    toggleTitle() {
      this.showTitle = !this.showTitle;
    },
  },

  beforeMount () {
    this.getData();
  },
};
